import $ from 'jquery';
import {} from '@ppcp/utils';
import {loadPayPalSdk} from "../../../../../assets/js/ppcp";

let bucket, paypal;

let data = {}

const getOption = (key, defaultValue) => {
    if (!data.hasOwnProperty(key)) {
        data[key] = defaultValue;
    }
    return data[key];
}

$(document).on('wfocuBucketCreated', async (e, bucket) => {
    bucket = bucket;

    if (window?.wfocu_vars?.wcPPCPData) {
        data = window.wfocu_vars.wcPPCPData;
    }

    // load the PayPal script
    try {
        paypal = loadPayPalSdk(getOption('queryParams'));
        const button = createPayPalButton();
        //button.render();
        if ($('.wfocu_upsell').length) {
            $('.wfocu_upsell').after('<div id="wc-ppcp-buttons"></div>');
            button.render(document.getElementById('wc-ppcp-buttons'));
        }
    } catch (error) {
        console.log(error);
    }


});

const createPayPalButton = () => {
    const button = paypal.Buttons({
        fundingSource: 'paypal',
        style: {},
        onInit: () => {
        },
        onClick: () => {
        },
        onApprove: () => {
        },
        onError: () => {
        },
        onCancel: () => {
        },
        createOrder: createOrder
    });
    return button;
}

const createOrder = () => {
}


